import styled from '@emotion/styled';
import { Switch } from '@mui/material';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.div`
  border: 1px solid #eee;
  border-radius: 16px;
  height: 10rem;
  font-family: 'metropolis', sans-serif;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

export const GroupCardContainer = styled.button`
  border: 1px solid #eee;
  border-radius: 16px;
  height: 10rem;
  font-family: 'metropolis', sans-serif;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  text-align: left;
  padding: 0;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  position: relative;

  &:hover {
    border-color: ${colors.GREEN_LEAF};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  }

  &:focus-visible {
    outline: 2px solid ${colors.GREEN_LEAF};
    outline-offset: 2px;
  }
`;

export const GroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 0.375rem 1rem;
  gap: 0.5rem;
`;

export const GroupTitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
`;

export const GroupBadge = styled.span<{ allActive?: boolean }>`
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  background: ${({ allActive }) => (allActive ? '#e6f7ec' : '#f1f3f5')};
  color: ${({ allActive }) => (allActive ? colors.GREEN_LEAF : colors.GRAY_DARKER)};
`;

export const GroupBody = styled.div`
  padding: 1rem;
  font-size: 0.875rem;
  color: ${colors.GRAY_DARKER};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const GroupFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.GREEN_LEAF};
  font-size: 0.8125rem;
  font-weight: 600;
`;

export const DialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #eee;
  font-family: 'metropolis', sans-serif;
`;

export const DialogTitleText = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DialogList = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  padding: 0.5rem 0;
`;

export const PermissionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  gap: 1rem;
  border-bottom: 1px solid #f4f4f4;
  font-family: 'metropolis', sans-serif;

  &:last-child {
    border-bottom: none;
  }
`;

export const PermissionRowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`;

export const PermissionRowName = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
`;

export const PermissionRowDescription = styled.span`
  font-size: 0.8125rem;
  color: ${colors.GRAY_DARKER};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 0.375rem 1rem;
`;

export const CardTitle = styled.h4`
  margin-block: 0.5rem;
  font-weight: 500;
  font-size: 1rem;
  font-weight: bold;
`;

export const CardBody = styled.div`
  padding: 1rem;
  overflow: auto;
  font-size: 0.875rem;
  color: ${colors.GRAY_DARKER};
  flex-grow: 1;
`;

export const StyledSwitch = styled(Switch)`
  & .MuiSwitch-switchBase.Mui-checked {
    color: ${colors.GREEN_LEAF};
  }

  & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${colors.GREEN_LEAF};
  }
`;
